import { render, staticRenderFns } from "./MinChecksActivity.vue?vue&type=template&id=910f776c&"
import script from "./MinChecksActivity.vue?vue&type=script&lang=js&"
export * from "./MinChecksActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports